import { PayloadAction } from '@reduxjs/toolkit';
import { CompanyMediaResponse, CompanyResponse, FAQResponse } from './state';
import { CompanyIntroduction, RentPlace, Terms } from './type';

const reducers = {
  getFAQs(state, action: PayloadAction<FAQResponse>) {
    state.faqs = action.payload;
    return state;
  },
  getTerm(state, action: PayloadAction<Terms>) {
    state.terms = action.payload;
    return state;
  },
  getRentPlace(state, action: PayloadAction<RentPlace>) {
    state.rent_place = action.payload;
    return state;
  },
  getCompanyHistory(state, action: PayloadAction<CompanyResponse>) {
    state.company_history = action.payload;
    return state;
  },
  getMediaNews(state, action: PayloadAction<CompanyMediaResponse>) {
    state.media_news = action.payload;
    return state;
  },
  getIntroduction(state, action: PayloadAction<CompanyIntroduction>) {
    state.introduction = action.payload;
    return state;
  },
};

export default reducers;
